import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'uui-grid-item',
  styleUrl: 'uui-grid-item.scss',
  shadow: true
})
export class UuiCol {
  @Prop({ reflect: true, mutable: true }) xs: number;
  @Prop({ reflect: true, mutable: true }) s: number;
  @Prop({ reflect: true, mutable: true }) m: number;
  @Prop({ reflect: true, mutable: true }) l: number;

  render() {
    return (
      <div
        class={{
          'uui-col': true,
          [`uui-col-xs-${this.xs}`]: !!this.xs,
          [`uui-col-s-${this.s}`]: !!this.s,
          [`uui-col-m-${this.m}`]: !!this.m,
          [`uui-col-l-${this.l}`]: !!this.l
        }}
      >
        <slot />
      </div>
    );
  }
}
